










import Vue from 'vue';
import { PROJECT_DISPLAY_NAME, CONTACT_EMAIL } from '@/constants';

export default Vue.extend({
  data() {
    return {
      PROJECT_DISPLAY_NAME,
      CONTACT_EMAIL,
    };
  },
});
